import React from 'react'
import Tooltip from '@SiteComponents/Tooltip'
import useTooltipDelay from '@Utils/UseTooltipDelay'
import Close from '@Images/bulk_action_bar_close.svg'

import './SelectedItems.scss'

interface SelectedItemsProps {
  readonly categoryName: string
  readonly categoryIcon?: React.ReactNode
  readonly selectedItemIds: (number | string)[]
  readonly selectedItemCaptions: string[]
  readonly includeType?: 'all' | 'any'
  resetItemSelection(): void
}

const SelectedItems: React.FC<SelectedItemsProps> = props => {
  const {
    categoryName,
    categoryIcon,
    selectedItemIds,
    selectedItemCaptions,
    includeType = 'all',
  } = props

  const {
    showTooltip,
    triggerShowTooltip,
    cancelTooltip,
  } = useTooltipDelay()

  const onMouseEnter = () => {
    if (oneItemSelected) { return }

    triggerShowTooltip()
  }

  const onMouseLeave = () => {
    cancelTooltip()
  }

  const numberOfItemsSelected = selectedItemIds.length
  const oneItemSelected = numberOfItemsSelected === 1

  const captions = selectedItemCaptions.join(', ')

  return (
    <div className="SelectedItems">
      <div className="SelectedItems__part SelectedItems__part1">
        {categoryIcon}
        <div className="SelectedItems__part-text">
          {categoryName}
        </div>
      </div>
      <div className="SelectedItems__part SelectedItems__part2">
        <div className="SelectedItems__part-text">
          {oneItemSelected ? 'include' : `include ${includeType} of`}
        </div>
      </div>
      <div
        className="SelectedItems__part SelectedItems__part3"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="SelectedItems__part-text">
          {numberOfItemsSelected === 1 ? selectedItemCaptions[0] : `${numberOfItemsSelected} items`}
        </div>
        <div className="SelectedItems__tooltip">
          {showTooltip && (
            <Tooltip
              text={captions}
            />
          )}
        </div>
      </div>
      <div
        className="SelectedItems__part SelectedItems__close"
        onClick={props.resetItemSelection}
      >
        <Close />
      </div>
    </div>
  )
}

export default SelectedItems
